import { connect } from "react-redux";

import { ErrorPage } from "./ErrorPage";

import type { State } from "../../reducers";

const mapStateToProps = (state: State) => ({
  error: state.ui.unhandledError,
  globalState: state,
});

export const ErrorPageContainer = connect(mapStateToProps)(ErrorPage);
